import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { setAssetsUrls as _setAssetsUrls } from '../../../state/actions/app';
import { setNewGames as _setNewGames, setFeaturedGames as _setFeaturedGames, setSlotGames as _setSlotGames, setTableGames as _setTableGames, setVipGames as _setVipGames, setFavouriteGames as _setFavouriteGames } from '../../../state/actions/game';
import { setInitAppResponse as _setInitAppResponse, setLastInitApp as _setLastInitApp, setIsInitAppExecuting as _setIsInitAppExecuting } from '../../../state/actions/load';
import { setModal as _setModal, setModalsLoaded as _setModalsLoaded } from '../../../state/actions/modal';
import { setXpBetMultiplier as _setXpBetMultiplier, setXp as _setXp, setXpPerSpin as _setXpPerSpin, setXpRequired as _setXpRequired } from '../../../state/slices/xp/xp';
import { setNextBoostLevel as _setNextBoostLevel, setNextBoostPercent as _setNextBoostPercent, setNextLevelBonusCoins as _setNextLevelBonusCoins, setCurrentLevelBonusCoins as _setCurrentLevelBonusCoins, setMaxLevel as _setMaxLevel } from '../../../state/slices/level/level';
import { setCasinoIdStatus as _setCasinoIdStatus, setCasinoId as _setCasinoId, setKYCStatus as _setKYCStatus, setPropertyName as _setPropertyName, setSoundSettings as _setSoundSettings, isAccountLinked as _isAccountLinked, setCurrentMemberLevel as _setCurrentMemberLevel, setIsDevUser as _setIsDevUser } from '../../../state/actions/playerInfo';
import { setSaleAvailable as _setSaleAvailable } from '../../../state/actions/shopList';
import { isOutOfCoinsPurchase as _isOutOfCoinsPurchase } from '../../../state/actions/prePurchase';
import { showVipAccessModal as _showVipAccessModal, setVipRoomUnlocked as _setVipRoomUnlocked, setOutOfCoinOfferResponse as _setOutOfCoinOfferResponse, setLTOOffer as _setLTOOffer, setTimedBonus as _setTimedBonus } from '../../../state/actions/consumables';
import { setVideosAdsInfo as _setVideosAdsInfo, setDefaultValuesForAppsflyerLinks } from '../../../state/actions/extras';
import BonusInterface from '../../../api/BonusInterface';
import { shiftPendingMessage, claimPendingMessage } from '../../../state/actions/pendingMessage';
import Screens from '../../../screens/index';
import QueryParamProxy from '../../../utils/queryParamProxy';
import RouteParamConstants, { BONUS_LINK } from '../../../utils/routeParamConstants';
import { setOnboardingUnlockLevel as _setOnboardingUnlockLevel, markOnboardingSeen as _markOnboardingSeen } from '../../../state/actions/ftue';
import { setDefaultPanels as _setDefaultPanels, setRegularPanels as _setRegularPanels, setStickyPanels as _setStickyPanels } from '../../../state/actions/panels';
import { setWelcomeNews as _setWelcomeNews, setLobbyNews as _setLobbyNews, setLobbyBackgroundPromo as _setLobbyBackgroundPromo } from '../../../state/actions/promotions';
import { shouldShowTooltip as _shouldShowTooltip, showFeatureCompleteTooltip as _showFeatureCompleteTooltip, tooltipDetails } from '../../../state/actions/tooltip';
import { sendPushNotification as _sendPushNotification, removePushNotification as _removePushNotification } from '../../../state/actions/notification';
import { setOnboardingFtueStep as _setOnboardingFtueStep, clearOnboarding as _clearOnboarding, setFtueState as _setFtueState, setFtueGameId as _setFtueGameId } from '../../../state/actions/currentOnboarding';
import store from '../../../state/store';
import { setActiveTutorial as _setActiveTutorial } from '../../../state/slices/tutorial/tutorial';
import { clearLastActionCommand as _clearLastActionCommand, setLastActionExecuted as _setLastActionExecuted } from '../../../state/slices/actionCommands/actionCommands';
import { postEvents as _postEvents } from '../../../state/query/events';
import { setRewardCenterNotification as _setRewardCenterNotification } from '../../../state/actions/rewardCenter';
export default (function (dispatch) {
  return {
    setAssetsUrls: function setAssetsUrls(assetsUrls) {
      dispatch(_setAssetsUrls(assetsUrls));
    },
    setNewGames: function setNewGames(gameList) {
      dispatch(_setNewGames(gameList));
    },
    setFeaturedGames: function setFeaturedGames(gameList) {
      dispatch(_setFeaturedGames(gameList));
    },
    setSlotGames: function setSlotGames(gameList) {
      dispatch(_setSlotGames(gameList));
    },
    setTableGames: function setTableGames(gameList) {
      dispatch(_setTableGames(gameList));
    },
    setVipGames: function setVipGames(gameList) {
      dispatch(_setVipGames(gameList));
    },
    setFavouriteGames: function setFavouriteGames(gameList) {
      dispatch(_setFavouriteGames(gameList));
    },
    setModal: function setModal(newModal) {
      dispatch(_setModal(newModal));
    },
    dismissModal: function dismissModal() {
      dispatch(_setModal(null));
    },
    setXp: function setXp(value) {
      dispatch(_setXp(value));
    },
    setXpBetMultiplier: function setXpBetMultiplier(value) {
      dispatch(_setXpBetMultiplier(value));
    },
    setXpPerSpin: function setXpPerSpin(value) {
      dispatch(_setXpPerSpin(value));
    },
    setXpRequired: function setXpRequired(value) {
      dispatch(_setXpRequired(value));
    },
    setMaxLevel: function setMaxLevel(value) {
      dispatch(_setMaxLevel(value));
    },
    setNextLevelBonusCoins: function setNextLevelBonusCoins(value) {
      dispatch(_setNextLevelBonusCoins(value));
    },
    setCurrentLevelBonusCoins: function setCurrentLevelBonusCoins(value) {
      dispatch(_setCurrentLevelBonusCoins(value));
    },
    setNextBoostPercent: function setNextBoostPercent(value) {
      dispatch(_setNextBoostPercent(value));
    },
    setNextBoostLevel: function setNextBoostLevel(value) {
      dispatch(_setNextBoostLevel(value));
    },
    setCasinoIdStatus: function setCasinoIdStatus(value) {
      dispatch(_setCasinoIdStatus(value));
    },
    setCasinoId: function setCasinoId(value) {
      dispatch(_setCasinoId(value));
    },
    setKYCStatus: function setKYCStatus(value) {
      dispatch(_setKYCStatus(value));
    },
    setSaleAvailable: function setSaleAvailable(value) {
      dispatch(_setSaleAvailable(value));
    },
    setLTOOffer: function setLTOOffer(value) {
      dispatch(_setLTOOffer(value));
    },
    setTimedBonus: function setTimedBonus(value) {
      dispatch(_setTimedBonus(value));
    },
    claimPendingMessages: function () {
      var _claimPendingMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pendingMessages) {
        var idx, pendingMessage, response, _QueryParamProxy$setQ, isValidLink, iterationCount;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _regeneratorRuntime.keys(pendingMessages);

              case 1:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 16;
                  break;
                }

                idx = _context.t1.value;
                pendingMessage = pendingMessages[idx];

                if (pendingMessage.hasClaimed) {
                  _context.next = 14;
                  break;
                }

                _context.t2 = pendingMessage.type;
                _context.next = _context.t2 === 'BONUS_LINK' ? 8 : 13;
                break;

              case 8:
                _context.next = 10;
                return BonusInterface.submitBonusableLink(pendingMessage);

              case 10:
                response = _context.sent;

                if (response) {
                  dispatch(claimPendingMessage(idx, response));
                  dispatch(setDefaultValuesForAppsflyerLinks(true, idx));
                  QueryParamProxy.setQueryParams((_QueryParamProxy$setQ = {}, _defineProperty(_QueryParamProxy$setQ, RouteParamConstants.PARAM_MODAL, Screens.BonusLinkMessage), _defineProperty(_QueryParamProxy$setQ, BONUS_LINK.HASH, null), _defineProperty(_QueryParamProxy$setQ, BONUS_LINK.ID, null), _QueryParamProxy$setQ));
                }

                return _context.abrupt("break", 14);

              case 13:
                return _context.abrupt("break", 14);

              case 14:
                _context.next = 1;
                break;

              case 16:
                //This is necessary if we click a link but that is claimed already.
                //If it is claimed already, we don't make API request and we need to show the error pop-up
                isValidLink = store.getState().appsFlyerValidation.isValidLink;
                iterationCount = store.getState().appsFlyerValidation.iterationCount;

                if (!isValidLink && iterationCount >= 0) {
                  dispatch(claimPendingMessage(0, {
                    redeem: false
                  }));
                  QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.BonusLinkMessage));
                }

                dispatch(setDefaultValuesForAppsflyerLinks(false, -1));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function claimPendingMessages(_x) {
        return _claimPendingMessages.apply(this, arguments);
      }

      return claimPendingMessages;
    }(),
    shiftPendingMessages: function shiftPendingMessages() {
      dispatch(shiftPendingMessage());
    },
    showVipAccessModal: function showVipAccessModal(value) {
      dispatch(_showVipAccessModal(value));
    },
    setVipRoomUnlocked: function setVipRoomUnlocked(value) {
      dispatch(_setVipRoomUnlocked(value));
    },
    setOutOfCoinOfferResponse: function setOutOfCoinOfferResponse(value) {
      dispatch(_setOutOfCoinOfferResponse(value));
    },
    isOutOfCoinsPurchase: function isOutOfCoinsPurchase(value) {
      dispatch(_isOutOfCoinsPurchase(value));
    },
    setVideosAdsInfo: function setVideosAdsInfo(value) {
      dispatch(_setVideosAdsInfo(value));
    },
    setOnboardingUnlockLevel: function setOnboardingUnlockLevel(onboarding, level) {
      dispatch(_setOnboardingUnlockLevel(onboarding, level));
    },
    setPropertyName: function setPropertyName(value) {
      dispatch(_setPropertyName(value));
    },
    setSoundSettings: function setSoundSettings(value) {
      dispatch(_setSoundSettings(value));
    },
    setDefaultPanels: function setDefaultPanels(value) {
      return dispatch(_setDefaultPanels(value));
    },
    setRegularPanels: function setRegularPanels(value) {
      return dispatch(_setRegularPanels(value));
    },
    setStickyPanels: function setStickyPanels(value) {
      return dispatch(_setStickyPanels(value));
    },
    setWelcomeNews: function setWelcomeNews(newsData) {
      dispatch(_setWelcomeNews(newsData));
    },
    setLobbyNews: function setLobbyNews(newsList) {
      dispatch(_setLobbyNews(newsList));
    },
    setLobbyBackgroundPromo: function setLobbyBackgroundPromo(background) {
      dispatch(_setLobbyBackgroundPromo(background));
    },
    isAccountLinked: function isAccountLinked(value) {
      dispatch(_isAccountLinked(value));
    },
    setCurrentMemberLevel: function setCurrentMemberLevel(value) {
      dispatch(_setCurrentMemberLevel(value));
    },
    setIsDevUser: function setIsDevUser(value) {
      dispatch(_setIsDevUser(value));
    },
    shouldShowTooltip: function shouldShowTooltip(value) {
      dispatch(_shouldShowTooltip(value));
    },
    markOnboardingSeen: function markOnboardingSeen(value) {
      dispatch(_markOnboardingSeen(value));
    },
    setLastInitApp: function setLastInitApp(value) {
      dispatch(_setLastInitApp(value));
    },
    setInitAppResponse: function setInitAppResponse(response) {
      dispatch(_setInitAppResponse(response));
    },
    showFeatureCompleteTooltip: function showFeatureCompleteTooltip(value) {
      dispatch(_showFeatureCompleteTooltip(value));
    },
    sendPushNotification: function sendPushNotification(playerId, notifiedFeature) {
      dispatch(_sendPushNotification(playerId, notifiedFeature));
    },
    setOnboardingFtueStep: function setOnboardingFtueStep(step) {
      dispatch(_setOnboardingFtueStep(step));
    },
    clearOnboarding: function clearOnboarding() {
      dispatch(_clearOnboarding());
    },
    removePushNotification: function removePushNotification(type) {
      dispatch(_removePushNotification(type));
    },
    setIsInitAppExecuting: function setIsInitAppExecuting(value) {
      dispatch(_setIsInitAppExecuting(value));
    },
    setModalsLoaded: function setModalsLoaded(value) {
      dispatch(_setModalsLoaded(value));
    },
    setTooltipDetails: function setTooltipDetails(value) {
      dispatch(tooltipDetails(value));
    },
    setActiveTutorial: function setActiveTutorial(value) {
      dispatch(_setActiveTutorial(value));
    },
    setLastActionExecuted: function setLastActionExecuted(value) {
      dispatch(_setLastActionExecuted(value));
    },
    setFtueState: function setFtueState(value) {
      dispatch(_setFtueState(value));
    },
    setFtueGameId: function setFtueGameId(value) {
      dispatch(_setFtueGameId(value));
    },
    postEvents: function postEvents(args, params) {
      dispatch(_postEvents.initiate(args, params));
    },
    setRewardCenterNotification: function setRewardCenterNotification(value) {
      dispatch(_setRewardCenterNotification(value));
    },
    clearLastActionCommand: function clearLastActionCommand() {
      dispatch(_clearLastActionCommand());
    }
  };
});